<template>
  <div class="text-center">
    <div v-if="metric === 'nps-0-10'">
      <p v-if="grade > 8" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade >= 7 && grade <= 8" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 6" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === 'nps-1-5'">
      <p v-if="grade >= 4" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade === 3" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 2" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === 'ces-1-5'">
      <p v-if="grade >= 4" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade === 3" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 2" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === 'csat-1-5'">
      <p v-if="grade >= 4" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade === 3" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 2" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === 'csat-0-10(media)'">
      <p v-if="grade > 8" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade >= 7 && grade <= 8" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 6" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === 'csat-1-5(media)'">
      <p v-if="grade >= 4" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade === 3" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 2" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === '5-stars'">
      <p v-if="grade >= 4" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade === 3" class="font-weight-bold">
        {{ neutralReply || defaultFeedback }}
      </p>
      <p v-else-if="grade <= 2" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
    <div v-else-if="metric === 'like-dislike'">
      <p v-if="grade == 1" class="font-weight-bold">
        {{ promotersReply || defaultFeedback }}
      </p>
      <p v-else-if="grade == 0" class="font-weight-bold">
        {{ detractorsReply || defaultFeedback }}
      </p>
      <p v-else class="font-weight-bold">
        {{ defaultFeedback }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultFeedback: {
      type: String,
      required: false,
      default: 'Qual o principal motivo da sua nota?',
    },
    promotersReply: String,
    neutralReply: String,
    detractorsReply: String,
    metric: String,
    grade: Number,
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/atoms/research-replys/index.vue